import React from "react";
import { Form } from "antd";
import { observer } from "mobx-react-lite";
import SupplierSelect from "@/components/SupplierSelect";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { Select } from "./BaseSelect";

interface SupplierFieldProps {
    shopId: number;
}

const SupplierField: React.FC<SupplierFieldProps> = function (props) {
    const { shopId } = props;
    const { retailerPartnershipsStore } = useOrderManagementStore();

    return (
        <Form.Item label={<span className="search-field-label">供货商</span>} name="supplierShopId">
            <SupplierSelect
                retailerShopId={shopId}
                retailerPartnershipsStore={retailerPartnershipsStore}
                skipCanBeEstablishedPartnerships
                RenderedSelect={Select}
            />
        </Form.Item>
    );
};

export default observer(SupplierField);
